import apiProduk from '@/api/vo-general/produk';

const defaultState = () => ({
	productList: [],
	productPagination: {},
  productDetail: {},
});

const state = defaultState();

const getters = {
};

const mutations = {
	setProductList(state, data) {
		data.results.map( (el) => {
			el['product_quantity'] = 1
			el['product_checked'] = false
			el['product_total'] = parseInt(el.product_quantity) * parseInt(el.product_price)
			return el;
		});
		state.productList = data.results;
		state.productPagination = data.pagination
  },
  setProductDetail(state, data) {
		state.productDetail = data.results;
	},
	emptyProductDetail(state) {
		state.productDetail = {};
	},
};

const actions = {
	getProductList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProduk.getProductList(params).then((results) => {
				const data = results.data.data
				commit('setProductList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getProductDetail({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProduk.getProductDetail(params).then((results) => {
				const data = results.data.data
				commit('setProductDetail', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};